"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import WaveDropQuote from "./WaveDropQuote";
import { useQuery } from "@tanstack/react-query";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { fetchQuorumParticipationDropPreviewBySerialNoV2 } from "@/services/api/quorum-participation-drop-preview-v2-api";
interface WaveDropQuoteWithSerialNoProps {
  readonly serialNo: number;
  readonly waveId: string;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropQuoteWithSerialNo: React.FC<WaveDropQuoteWithSerialNoProps> = t0 => {
  const $ = _c(11);
  const {
    serialNo,
    waveId,
    onQuoteClick,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth,
    onLinkCardActionsActiveChange
  } = t0;
  let t1;
  if ($[0] !== serialNo || $[1] !== waveId) {
    t1 = {
      queryKey: [QueryKey.DROP, "wave-drop-quote-serial", {
        waveId,
        serialNo
      }],
      queryFn: async () => fetchQuorumParticipationDropPreviewBySerialNoV2({
        waveId,
        serialNo
      })
    };
    $[0] = serialNo;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: t2
  } = useQuery(t1);
  const drop = t2 === undefined ? null : t2;
  let t3;
  if ($[3] !== drop || $[4] !== embedDepth || $[5] !== embedPath || $[6] !== maxEmbedDepth || $[7] !== onLinkCardActionsActiveChange || $[8] !== onQuoteClick || $[9] !== quotePath) {
    t3 = <WaveDropQuote drop={drop} partId={1} onQuoteClick={onQuoteClick} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[3] = drop;
    $[4] = embedDepth;
    $[5] = embedPath;
    $[6] = maxEmbedDepth;
    $[7] = onLinkCardActionsActiveChange;
    $[8] = onQuoteClick;
    $[9] = quotePath;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default WaveDropQuoteWithSerialNo;